<template>  
  <section class="shop-by">
    <div class="shop-by__wrapper" ref="wrapper">
      <div class="shop-by__tab-selector">
        <h3 class="preheader">{{schema.heading}}</h3>
        <div class="shop-by__tabs" ref="tabs">
          <span class="shop-by__bar" :style="barStyles" />
          <button 
            v-for="(block, i) in blocks" 
            :key="block.title"
            class="shop-by__tab link link--secondary"
            :class="[selectedTab === i ? 'shop-by__tab--selected': '']"
            @click="selectTab(i)"
            ref="tab_select"
          >
            <span>{{block.title}}</span>
          </button>
        </div>
      </div>
      <div class="shop-by__tabs-area">
        <span class="shop-by__arrow" :style="arrowStyles" />
        <div
          class="shop-by__tabs-tab"
        >
          <transition-group name="shop-list-slide" mode="in-out" tag="ul">
            <li
              v-for="(link, i) in blocks[selectedTab].link_list"
              :key="`${i}${link.link_title}`"
            >
              <v-link secondary :href="link.link_url">{{link.link_title}}</v-link>
            </li>
          </transition-group>
          <div class="shop-by__image">
            <div class="image-wrapper">
              <image-ratio :src="blocks[selectedTab].image" :alt="blocks[selectedTab].image_alt" ratio="3:4" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ImageRatio from '@/scripts/components/basic/ImageRatio.vue';
import VLink from '@/scripts/components/buttons/VLink.vue';


export default {
  name: 'ShopBy',
  props: {
    schema: Object,
    blocks: Array
  },
  components: {
    ImageRatio,
    VLink,
  },
  created() {
    // limit the length of each link list to 10
    this.blocks.map((block) => {
      block.link_list = block.link_list.slice(0,10);
      return block;
    });
  },
  mounted() {
    let wrapper = this.$refs.wrapper.offsetTop;
    let theTab = this.$refs.tab_select[0];
    let theTop = theTab.offsetTop;
    let theHeight = theTab.clientHeight/2;
    this.selectedLeft = theTab.offsetLeft
    this.selectedTabTop = theTop + theHeight;
    this.selectedWidth = theTab.clientWidth;
    
    this.observer = new ResizeObserver(entries => {
      let tab = this.$refs.tab_select[this.selectedTab];
      this.selectedWidth = tab.clientWidth;
      this.selectedLeft = tab.offsetLeft;
      this.selectedTabTop = tab + theHeight;
    });

    this.observer.observe(this.$refs.tabs);

  },
  data () {
    return {
      selectedTab: 0,
      selectedTabTop: 0,
      selectedLeft: 0,
      selectedWidth: 0,
      observer: null,
    }
  },
  computed: {
    arrowStyles() {
      return {
        top: `${this.selectedTabTop}px`
      }
    },
    barStyles() {
      return {
        left: `${this.selectedLeft}px`,
        width: `${this.selectedWidth}px`
      }
    },
  },
  methods: {
    selectTab(i) {
      let theTab = this.$refs.tab_select[i];
      let theTop = theTab.offsetTop;
      let theHeight = theTab.clientHeight/2;

      this.selectedTab = i;
      this.selectedTabTop = theTop + theHeight;
      this.selectedLeft = theTab.offsetLeft
      this.selectedTabTop = theTop + theHeight;
      this.selectedWidth = theTab.clientWidth;
    },
  }
}
</script>

<style scoped lang="scss">
.shop-by {
  padding: 56px 20px 56px;
  max-width: 1440px;
  margin: 0 auto;

  @include tablet-up {
    padding: 86px 20px 116px;
  }

  @include desktop-up {
    padding: 86px 120px 116px;
  }

  @include hd-up {
    padding: 86px 40px 116px;
  }
}

.shop-by__wrapper {
  
  @include tablet-up {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  @include desktop-up {
    display: grid;
    grid-template-columns: 1fr 2fr;
  }
}

.shop-by__tab-selector {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;

  .preheader {
    margin-bottom: 10px;
  }

  @include tablet-up {
    border-right: 1px solid $color-black-300;
    .preheader {
      margin-bottom: 30px;
    }
  }
}

.shop-by__tabs {
  display: flex;
  justify-content: space-between;
  position: relative;
  
  @include tablet-up {
    position: static;
    display: flex;
    flex-direction: column;
  }

  &:after {
    content: '';
    display: block;
    position: absolute;
    height: 1px;
    width: 100%;
    background-color: $color-black-300;
    bottom: 0;
    z-index: 1;
    
    @include tablet-up {
      display: none;
    }
  }
}

.shop-by__tabs-area {
  height: 475px;
  position: relative;
  overflow: hidden;

  @include tablet-up {
    height: 600px;
  }
}

.shop-by__tab {
  color: $color-green-slate-200;
  font-family: $font-family-primary;
  font-size: rem(16);
  line-height: rem(23);
  position: relative;
  text-align: left;
  text-transform: uppercase;
  white-space: nowrap;

  @include tablet-up {
    font-size: rem(32);
    line-height: rem(42);
    margin-bottom: 30px;
  }
  span {
    position: relative;
  }
  &:after {
    display: none;

    @include tablet-up {
      display: block;
    }
  }

  &--selected {
    color: $color-black-900;

    &:after {
      width: 100%;
    }
  }
}

.shop-by__arrow {
  @include tablet-up {
    background-color: $color-off-white;
    position: absolute;
    display: block;
    height: 20px;
    width: 20px;
    left: 0;
    top: 50%;
    transform: translate(-50%, -50%) rotateZ(45deg);
    transition: all .75s $default-animation-timing;
  }
}

.shop-by__bar {
  position: absolute;
  bottom: 0;
  height: 1px;
  background-color: $color-black-900;
  transition: all .6s $default-animation-timing;
  z-index: 2;

  @include tablet-up {
    display: none;
  }
}

.shop-by__tabs-tab {
  display: flex;
  height: 100%;

  ul {
    margin: 0;
    padding: 36px 0 0 0;
    @include tablet-up {
      padding: 0 0 0 40px;
      grid-column: span 2;
    }
    @include hd-up {
      padding: 0 20px 0 66px;
      grid-column: span 1;
    }
  }

  .link--secondary {
    font-size: rem(22);
    line-height: rem(29);
    margin-bottom: 10px;

    @include tablet-up {
      color: $color-black-600;
      font-size: rem(24);
      line-height: rem(31);
    }

    @include desktop-up {
      color: $color-black-600;
      font-size: rem(28);
      line-height: rem(37);
    }

    &:hover {
      color: $color-text-black;
    }
  }

  li:last-child .link--secondary {
    margin-bottom: 0;
  }
  @include tablet-up {
    align-items: center;
    grid-template-columns: repeat(3, 1fr);
    display: grid;
  }

  @include hd-up {
    align-items: center;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
}

.shop-by__image {
  display: none;

  @include desktop-up {
    display: block;
  }

  .image-wrapper {
    max-width: 370px;
    margin: 0 auto;
  }
}
</style>
